var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrap"}},[_c('NavMenu'),_c('div',{staticClass:"wrap-right"},[_c('Header'),_c('div',{staticClass:"v3-main"},[_c('el-main',{staticClass:"v3-content-main"},[_c('keep-alive',{attrs:{"include":_vm.navTagIndexs}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }